export enum PlaceType {
  OnSite = 1,
  Online = 2,
  Both = 3
}
